<template>
  <div>
    <b-modal
      id="suppliers-modal"
      cancel-variant="outline-secondary"
      centered
      :title="$t('selecting_a_supplier_from_the_registry')"
      size="lg"
      hide-footer
    >
      <AppSearchInput
        :label="$t('search') + ':'"
        :placeholder="$t('search') + '...'"
        @callback="search"
      />
      
      <b-table
        small
        :fields="fields"
        :items="response.results"
        responsive
        :tbody-tr-class="['tableRowClass']"
        class="mt-2"
        sticky-header="300px"
        :no-border-collapse="true"
        show-empty
        :empty-text="$t('empty_text')"
      >
        <template #head()="props">
          <span>{{ $t(props.label) }}</span>
        </template>
        
        <!-- Компания -->
        <template #cell(company)="data">
          <span>
            {{ data.item.company.title }}
          </span>
        </template>

        <!-- Контакты -->
        <template #cell(contacts)="data">
          <ul class="list-unstyled m-0">
            <li class="d-flex align-items-center">
              <feather-icon icon="MailIcon" />
              <span class="ml-1">{{ data.item.email }}</span>
            </li>
            <li class="d-flex align-items-center">
              <feather-icon icon="PhoneIcon" />
              <span class="ml-1">+{{ data.item.phone_number }}</span>
            </li>
          </ul>
        </template>

        <!-- Контрагент -->
        <template #cell(contact_agent)="{ value }">
          <ul class="list-unstyled m-0">
            <template v-for="(item, index) in value">
              <span
                v-if="index < 1"
                :key="item.id"
              >
                <li class="d-flex align-items-center">
                  <feather-icon icon="UserIcon" />
                  <span class="ml-1">{{ item.name }}</span>
                </li>
                <li class="d-flex align-items-center">
                  <feather-icon icon="SmartphoneIcon" />
                  <span class="ml-1">+{{ item.phone_number }}</span>
                </li>
              </span>
            </template>
          </ul>
        </template>

        <!-- Действия -->
        <template #cell(actions)="{ item }">
          <div>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              class=""
              variant="primary"
              @click="addSeller(item)"
            >
              {{$t('general.select')}}
            </b-button>
          </div>
        </template>
      </b-table>

      <Pagination
        :rows="response.count"
        :params="params"
        @refresh="refresh"
      />

    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BModal, VBModal, BTable,
} from 'bootstrap-vue'
import { mapActions, mapGetters } from 'vuex'
import Ripple from 'vue-ripple-directive'
import AppSearchInput from '@/components/AppSearchInput.vue'
import Pagination from '@/components/Pagination.vue'

export default {
  components: {
    BButton,
    BModal,
    BTable,
    AppSearchInput,
    Pagination,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      params: {
        page_size: 10,
        page: 1,
        search: '',
        type: 'provider'
      },
      response: [],
      fields: [
        {
          label: 'company',
          key: 'company_name',
        },
        {
          label: 'inn',
          key: 'inn',
        },
        {
          label: 'contact.contacts',
          key: 'contacts',
        },
        {
          label: 'contact.kontragent',
          key: 'contact_agent',
        },
        {
          label: 'actions',
          key: 'actions',
        },
      ],
    }
  },
  async mounted() {
    await this.refresh()
  },
  computed: {
    ...mapGetters('contacts', ['GET_CONTACTS_TABLE_LIST']),
  },
  methods: {
    ...mapActions('contacts', ['FETCH_ALL_CONTACTS_LIST']),
    
    async refresh(){
      this.response = await this.FETCH_ALL_CONTACTS_LIST(this.params)
    },
    addSeller(e) {
      this.$emit('input', e)
      this.$bvModal.hide('suppliers-modal')
    },
    async search(e) {
      this.$set(this.params, 'search', e)
      this.params.page = 1
      await this.refresh()
    },

  },
}
</script>

<style lang="scss">

</style>
